export default "__VITE_ASSET__4aa4ed8f__"